import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { Message } from "../..";
import Loader from "../Loader";
import { getClientsCount, resetClientsCount } from "../../../../redux/actions/contractAction";
import { createArrayYears, dataYears } from "../../../../helpers/common";
import {
  clientCountValues,
  viewReports,
} from "../../../../helpers/data-constants";
import { ActionButton } from "../../../common";
import CrossIcon from "../../../../assets/icons/cross.svg";

import "./layoutClientsCountReport.scss";

export const LayoutClientsCountReport = ({ onClose, title }) => {
  const dispatch = useDispatch();
  const { clientsCount, commonError } = useSelector(({ contract }) => contract);
  const [state, setState] = useState(null);
  const [reportTitle, setReportTitle] = useState(null);
  const [loading, setLoading] = useState(true);

  const availableYears = createArrayYears().map((year) => ({
    value: year,
    label: year,
  }));

  const defaultValue = availableYears[availableYears.length - 1];

  const handleClose = () => {
    dispatch(resetClientsCount());
    onClose();
  };

  const chooseYears = (selectedYear) => {
    setReportTitle(null);
    setState(
      dataYears(
        selectedYear,
        viewReports.CLIENTS_COUNT,
        viewReports.CLIENTS_COUNT
      )
    );
  };

  const callReport = ({ title, dateFrom, dateTo, viewReport }) => {
    setReportTitle(title);
    dispatch(getClientsCount({ dateFrom, dateTo }, viewReport));
  };

  const reportValues = clientCountValues(clientsCount || {});

  const createButtons = (data) =>
    Object.values(data).map((item) => (
      <ActionButton
        key={item.title}
        text={item.title}
        styleName={
          item.title === reportTitle
            ? "client-report reports-disabled-item"
            : "button-pillbox"
        }
        func={callReport}
        param={item}
        disabled={item.title === reportTitle}
      />
    ));

  const renderReportValues = () =>
    Object.entries(reportValues).map(([label, value]) => (
      <div className="info-row" key={label}>
        <label>{label}:</label>
        <span className="dashed"></span>
        <span>{value}</span>
      </div>
    ));

  useEffect(() => {
    setLoading(false);
    setState(
      dataYears(
        defaultValue,
        viewReports.CLIENTS_COUNT,
        viewReports.CLIENTS_COUNT
      )
    );
  }, []);

  return (
    <>
      {commonError && <Message type="error" text={commonError} />}
      <div className="modal-header flex-column">
        <div className="d-flex fullwidth">
          <h2 className="header-title">{title}</h2>
          <button
            className="button-icontrigger modal-closetrigger"
            onClick={handleClose}
          >
            <span className="icon">
              <CrossIcon />
            </span>
          </button>
        </div>
        <span className="m-t-spacer">
          Количество анкет клиентов на конец отчетного периода, имеющие активные
          договоры.
        </span>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="modal-body">
          <fieldset>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label">Дата</label>
                  <Select
                    classNamePrefix="select"
                    className="basic-multi-select select-width"
                    placeholder="Выберите год"
                    options={availableYears}
                    onChange={chooseYears}
                    noOptionsMessage={() => "Нет результатов"}
                    defaultValue={defaultValue}
                  />
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label">Квартал</label>
                  <div className="quarter-button-container">
                    {state && createButtons(state.quarter)}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-row-item fullwidth">
                <div className="form-element">
                  {renderReportValues()}
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      )}
    </>
  );
};
